<template>
  <pt-work-order-detail class="pt-work-order-detail__page"></pt-work-order-detail>
</template>

<script>
import PtWorkOrderDetail from 'cps/work-order/pt-consulting-subscribe-order/pt-work-order-detail/withData'
export default {
  name: 'pt-work-order-detail__view',
  components: {
    'pt-work-order-detail': PtWorkOrderDetail
  }
}
</script>
